import { render, staticRenderFns } from "./vendorNewCreate.vue?vue&type=template&id=257f186a&"
import script from "./vendorNewCreate.vue?vue&type=script&lang=js&"
export * from "./vendorNewCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports